import { Lightning } from "@lightningjs/sdk";
import { gridHeight, gridWidth } from "../../services/grid.service";

export default class Loader extends Lightning.Component {
  static _template() {
    return {
      Loader: {
        alpha: 0,
        LoaderRectOne: {
          x: 11.4 * gridWidth,
          y: 20 * gridHeight,
          w: 0.3 * gridWidth,
          h: 0.07 * gridWidth,
          color: 0xffffffff,
          rect: true,
        },
        LoaderRectTwo: {
          x: 11.2 * gridWidth,
          y: 20.25 * gridHeight,
          w: 0.7 * gridWidth,
          h: 0.07 * gridWidth,
          color: 0xffffffff,
          rect: true,
        },
        LoaderRectThree: {
          x: 11.3 * gridWidth,
          y: 20.5 * gridHeight,
          w: 0.5 * gridWidth,
          h: 0.07 * gridWidth,
          color: 0xffffffff,
          rect: true,
        },
      },
    };
  }
  _active() {
    this.loaderRectOneAnimation = this.tag("LoaderRectOne").animation({
      duration: 6,
      repeat: -1,
      stopMethod: "immediate",
      actions: [
        {
          p: "alpha",
          v: {
            0: 1,
            0.15: 0.5,
            0.3: 0.2,
            0.45: 1,
            0.5: 0.5,
            0.75: 0.2,
            0.9: 1,
            1: 0.5,
          },
        },
      ],
    });
    this.loaderRectTwoAnimation = this.tag("LoaderRectTwo").animation({
      duration: 6,
      repeat: -1,
      stopMethod: "immediate",
      actions: [
        {
          p: "alpha",
          v: {
            0: 0.5,
            0.15: 1,
            0.3: 0.2,
            0.45: 0.5,
            0.6: 1,
            0.75: 0.2,
            0.9: 0.5,
            1: 1,
          },
        },
      ],
    });
    this.loaderRectThreeAnimation = this.tag("LoaderRectThree").animation({
      duration: 6,
      repeat: -1,
      stopMethod: "immediate",
      actions: [
        {
          p: "alpha",
          v: {
            0: 0.2,
            0.15: 0.5,
            0.3: 1,
            0.45: 0.2,
            0.6: 0.5,
            0.75: 1,
            0.9: 0.2,
            1: 0.5,
          },
        },
      ],
    });

    this.application.on("loader_animation_start", () => {
      this.loaderStart();
    });
    this.application.on("loader_animation_stop", () => {
      this.loaderStop();
    });
  }

  loaderStart() {
    this.tag("Loader").patch({ smooth: { alpha: 1 } });
    this.loaderRectOneAnimation.start();
    this.loaderRectTwoAnimation.start();
    this.loaderRectThreeAnimation.start();
  }

  loaderStop() {
    this.tag("Loader").patch({ smooth: { alpha: 0 } });
    this.loaderRectOneAnimation.stop();
    this.loaderRectTwoAnimation.stop();
    this.loaderRectThreeAnimation.stop();
  }
}
